import { controlStyle, inputStyle, menuListStyle, menuPortalStyle, noOptionsMessageStyle } from './helpers';
export var MAX_DESKTOP_LIST_HEIGHT = 132;
export var MAX_MOBILE_LIST_HEIGHT = 228;
export var MAX_MOBILE_LIST_HEIGHT_FOR_SMALL_SCREEN = 170;
export var MAX_MULTIPLE_MOBILE_LIST_HEIGHT = 307;
export var MOBILE_ROW_HEIGHT = 57;
export var MOBILE_POPUP_HEADER_HEIGHT = 54;
export var MOBILE_POPUP_FOOTER_HEIGHT = 80;
export var types = ['date', 'unbordered'];

var returnerObj = function returnerObj() {
  return {};
};

export var style = {
  control: controlStyle,
  dropdownIndicator: returnerObj,
  indicatorsContainer: returnerObj,
  input: inputStyle,
  menu: returnerObj,
  menuList: menuListStyle,
  multiValue: returnerObj,
  multiValueLabel: returnerObj,
  multiValueRemove: returnerObj,
  noOptionsMessage: noOptionsMessageStyle,
  option: returnerObj,
  placeholder: returnerObj,
  singleValue: returnerObj,
  valueContainer: returnerObj,
  group: returnerObj,
  groupHeading: returnerObj,
  menuPortal: menuPortalStyle
};